module.exports = __webpack_public_path__ + "static/media/loginExtensis.0dcc8960.webp";